import { combineReducers } from 'redux';

import authService from '@app/libs/auth/authService';
import documentAuthService from '@app/libs/auth/documentAuthService';
import { AccountAction } from '@app/store/account/actions';
import { signInSuccess } from '@app/store/account/local/actions';
import { thirdPartySignInSuccess } from '@app/store/account/third-party/actions';
import {
  ACCOUNT_AUTHENTICATION_RESET,
  ACCOUNT_AUTHENTICATION_SET,
  ACCOUNT_LOAD_SUCCESS,
  ACCOUNT_SECESSION_FAILURE,
  ACCOUNT_SECESSION_REQUEST,
  ACCOUNT_SECESSION_SUCCESS,
  ACCOUNT_SIGN_OUT_SUCCESS,
} from '@app/store/actionTypes';

import password from './password/reducers';
import signUp from './sign-up/reducers';
import survey from './survey/reducers';

type AccountIsAccountRemovingState = boolean;

export function isAccountRemoving(
  state: AccountIsAccountRemovingState = false,
  action: AccountAction
) {
  switch (action.type) {
    case ACCOUNT_SECESSION_REQUEST:
      return true;
    case ACCOUNT_SECESSION_SUCCESS:
    case ACCOUNT_SECESSION_FAILURE:
      return false;
    default:
      return state;
  }
}

type AccountIsAuthenticatedState = boolean;

const hasValidAuthCredential: AccountIsAuthenticatedState =
  authService.hasAccessToken() &&
  // TODO(@highcastlee): refreshToken 정상 도입 후 refreshToken 만료만 확인하도록 수정합니다.
  (authService.hasRefreshToken()
    ? !authService.isRefreshTokenExpired()
    : !authService.isAccessTokenExpired()) &&
  !documentAuthService.isLinkUser();

export function isAuthenticated(
  state: AccountIsAuthenticatedState = hasValidAuthCredential,
  action: AccountAction
) {
  switch (action.type) {
    case ACCOUNT_AUTHENTICATION_SET:
      return action.payload;
    case ACCOUNT_LOAD_SUCCESS:
    case signInSuccess.type:
    case thirdPartySignInSuccess.type:
      return true;
    case ACCOUNT_AUTHENTICATION_RESET:
    case ACCOUNT_SIGN_OUT_SUCCESS:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  isAccountRemoving,
  isAuthenticated,
  password,
  signUp,
  survey,
});
